import { redirect } from "@tanstack/react-router"

import type { Session } from "@/types/auth"

export function portalOrganisations(session: Session): string[] {
  return [...new Set(session.portal.map((entry) => entry.organisationId))]
}

export function redirectToLanding(
  session: Session,
  remembered: string | null
): never {
  const [only, ...others] = session.organisations
  const last = session.organisations.find(
    (membership) => membership.id === remembered
  )

  const entered = last ?? (others.length === 0 ? only : undefined)

  if (entered) {
    throw redirect({
      to: "/$organisation",
      params: { organisation: entered.id },
    })
  }

  if (only) {
    throw redirect({ to: "/organisations/select" })
  }

  if (session.user.admin) {
    throw redirect({ to: "/admin" })
  }

  const portals = portalOrganisations(session)
  const [onlyPortal] = portals

  if (onlyPortal && portals.length === 1) {
    throw redirect({
      to: "/$organisation/portal",
      params: { organisation: onlyPortal },
    })
  }

  throw redirect({
    to: portals.length > 0 ? "/organisations/select" : "/organisations/none",
  })
}
